import {
  ResponsiveContainer,
  BarChart,
  YAxis,
  XAxis,
  Tooltip,
  Bar,
  LabelList,
} from "recharts";
import approximateScore from "../../utils/approximate-scores";
import cowboy from "../../assets/img/sad-cowboy.png";
import { CoolHeading } from "../CoolHeading";
import { HighScore, Player } from "../../types";

type ScoreChartProps = {
  data: HighScore[];
  machineGroupName: string;
  machineColor?: string;
  roster: Player[];
};

export default function ScoreChart({
  data,
  machineGroupName,
  machineColor,
  roster,
}: ScoreChartProps) {
  const dataWithFill = data.map((item) => {
    return {
      ...item,
      fill: machineColor || "#8884d8",
    };
  });

  const chartHeight = (() => {
    if (dataWithFill.length > 40) return "h-[48rem]";
    if (dataWithFill.length > 20) return "h-[28rem]";
    if (dataWithFill.length > 10) return "h-[16rem]";
    return "h-[12rem]";
  })();

  return (
    <div
      className={`flex ${chartHeight} w-full flex-col items-center rounded-xl bg-gray-300/60 p-2 dark:bg-gray-700`}
    >
      <CoolHeading
        variant="fixed"
        className="mb-4 mt-1 text-wrap text-center text-xs"
      >
        {machineGroupName}
      </CoolHeading>
      {dataWithFill.length > 0 ? (
        <ResponsiveContainer width={"100%"} height={"100%"}>
          <BarChart
            data={dataWithFill}
            layout="vertical"
            margin={{
              right: 48,
            }}
          >
            <YAxis type="category" dataKey="machineGroupId" hide={true} />
            <XAxis type="number" domain={[0, 10]} hide={true} />
            <Tooltip
              shared={false}
              wrapperClassName="rounded-xl"
              formatter={(value, name, props) => {
                const playerName =
                  roster.find((p) => p.id === props?.payload?.playerId)?.name ||
                  "Unknown Player";
                const machineScore = props?.payload?.score;
                return [
                  <div className="flex flex-col p-2 text-xs normal-case">
                    <span>{playerName}</span>
                    <span>
                      {approximateScore(machineScore)} ({value.toLocaleString()}
                      )
                    </span>
                    <span>{props?.payload?.venueName}</span>
                  </div>,
                ];
              }}
            />
            <Bar dataKey="rating">
              <LabelList
                dataKey={"score"}
                position="right"
                formatter={(value) =>
                  approximateScore(Number(value)).toLocaleString()
                }
                className="fill-black dark:fill-white"
                style={{ fontSize: "8px", fontWeight: "bold" }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="flex h-full flex-col items-center justify-center">
          <p className="text-center text-gray-300 dark:text-gray-500">
            No scores available{" "}
          </p>

          <img className="h-4" src={cowboy} alt="Sad cowboy" />
        </div>
      )}
    </div>
  );
}
